import { COLORS } from '../../../constants/style/color';
import styled from 'styled-components';
import { rem } from '../../../utils/style';
import Button from '../../button';
import TextareaAutosize from 'react-textarea-autosize';

export const ChatContainer = styled.div`
  .notification {
    padding: ${rem(15)} ${rem(32)};
    border-bottom: 1px solid ${COLORS.CulturedWhite};
    position: relative;
    justify-content: space-between;

    &:last-child {
      border-bottom: none;
    }

    &::before {
      content: '';
      position: absolute;
      top: ${rem(20)};
      left: ${rem(32)};
      width: 9px;
      height: 9px;
      border-radius: ${rem(2)};
      background-color: ${COLORS.Purple};
    }

    &.notification-seen::before {
      background-color: ${COLORS.Green};
    }

    &-title {
      margin-bottom: ${rem(5)};
      padding-left: ${rem(14)};
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    &-date {
      color: ${COLORS.SpanishGray};
      padding-left: ${rem(14)};
    }

    &-delete {
      color: ${COLORS.Red};
      font-size: ${rem(20)};
      cursor: pointer;
      margin-top: ${rem(2.5)};
    }

    &-loader {
      padding-top: ${rem(16)};
    }

    &-view {
      margin-top: 6px;
      padding: ${rem(24)};
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const ChatHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${rem(12.5)};
  border-bottom: 1px solid ${COLORS.LightGray};
`;

export const ChatModalContainer = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  // position: fixed;
  // top: 50%;
  // right: -10%;
  // transform: translate(-50%, -50%);
  background-color: ${COLORS.White};
  padding: 20px;
  border-radius: 8px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  z-index: 1000;

  .modal-close {
    display: flex;
    align-items: center;
    column-gap: ${rem(2)};
    cursor: pointer;
    span {
      transition: all 0.5s 0s ease;
    }
    &:hover {
      span {
        color: ${COLORS.Red};
      }
    }
  }
  .linked-text {
    color: ${COLORS.Purple};
  }
  .linked-text a {
    color: ${COLORS.Purple};
  }
  .minimize-icon-color:hover {
    color: ${COLORS.Purple} !important;
  }
`;

export const ChatHTMLElement = styled.span`
  a {
    color: ${COLORS.Purple};
  }
`;

export const InputModuleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;


export const StyledTextareaAutosize = styled(TextareaAutosize)`
  resize: none;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    // background: #f1f1f1;
    border-radius: 7px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: 7px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const Input = styled.input`
  // border: 1px solid lightgray;
  // border-radius: 4px;
  // flex-grow: 1;
  // margin-right: 10px;
  // padding: 6px 12px; // Adjust padding as needed
  // font-size: 16px; // Match your design
  // line-height: 1.5; // For better readability
  // // resize: none; // Prevent manual resizing
  // overflow-y: auto; // Show scrollbar when content overflows
  min-height: 30px; // Minimum height to match your design
  // height: 30px;
  max-height: 100px; // Maximum height before scrollbar appears
  width: 100%;
`;
export const ResponseArea = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;

  h1 {
    font-size: ${rem(18)};
    font-weight: bold;
    color: ${COLORS.Purple};
    margin-bottom: ${rem(10)};
    text-align: left; // Ensure alignment
  }

  h2 {
    font-size: ${rem(20)};
    font-weight: bold;
    color: ${COLORS.Purple};
    margin-bottom: ${rem(8)};
  }

  p {
    margin: ${rem(10)} 0;
  }

  ul {
    list-style-type: disc;
    margin: ${rem(10)} 0;
    padding-left: ${rem(20)};
  }

  li {
    margin-bottom: ${rem(5)};
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: ${rem(20)} 0;
  }

  th, td {
    border: 1px solid ${COLORS.LightGray};
    padding: ${rem(10)};
    text-align: left;
    font-size: clamp(0.8rem, 1vw, 1.2rem); /* Adjusts font size based on viewport width */
    word-wrap: break-word; /* Ensures long words wrap inside the cell */
  }
  th {
    background-color: ${COLORS.CulturedWhite};
    font-weight: bold;
  }
`;

export const ChatButton = styled(Button)`
  height: 39px;
  width: 40px;
`;

export const VerticalSpacer = styled.div`
  height: 20px;
`;

interface ChatMessageProps {
  right: boolean;
}

export const ChatMessageSpan = styled.span<ChatMessageProps>`
  word-break: break-word;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  max-width: 85%; // Slightly increase max width for larger messages
  text-align: left;
  margin-left: ${({ right }) => (right ? 'auto' : 'initial')};
  margin-right: ${({ right }) => (right ? 'initial' : 'auto')};
  color: ${({ right }) => (right ? 'white' : 'gray-800')};
  background-color: ${({ right }) => (right ? COLORS.Purple : 'rgb(229 231 235 / 1)')};
  font-size: ${rem(14)};
  
  word-break: break-word;
  overflow-wrap: break-word; /* Ensures long words break properly */
  
  // Ensure nested elements like <p>, <table>, etc., are styled correctly
  p {
    margin: 10px 0; // Add spacing between paragraphs
  }

  table {
    margin: 20px 0; // Space around tables
    width: 100%;
    border: 1px solid ${COLORS.LightGray};
  }
    /* Add these styles for code blocks */
  code {
    display: inline-block;
    max-width: 100%;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    word-break: break-word;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
    font-size: 0.9em;
  }

  pre code {
    display: block;
    padding: 0.5em;
    margin: 0.5em 0;
    overflow: auto;
  }

`;


export const FloatingChatButton = styled.button`
  position: fixed;
  bottom: ${rem(20)};
  right: ${rem(20)};
  background-color: ${COLORS.Purple};
  color: white;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  }
`;
